<script lang="ts">
	import InputInline from '../InputInline.svelte';
	import type { InputNumberProps } from '../types';

	export let props: InputNumberProps;

	if (props) {
		props.min = props.min ?? 0;
		props.max = props.max;
		props.step = props.step ?? 1;
	}

	const handleAllowNumbers = (e: KeyboardEvent) => {
		if (!/^[\d,]+$/.test(e.key)) {
			e.preventDefault();
		}
	};
</script>

<InputInline
	type="number"
	bind:props
	min={props.min}
	max={props.max}
	step={props.step}
	on:keypress={(e) => handleAllowNumbers(e)}
	on:change
/>
